export default {
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  cognito: {
    poolId:
      'eu-west-1:b77632ec-1699-48f7-a294-98db07aa0b64'
  },
  lex: {
    botName: 'VoyagerSandbox',
    initialText: 'Hi'
  },
  ui: {
    toolbarTitle: 'Help Bot',
    toolbarLogo: ''
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js